"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const ListIcon_vue_1 = __importDefault(require("./ListIcon.vue"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let StudySummaryDownload = class StudySummaryDownload extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.resetInput = false;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    downloadReport(mode) {
        var _a, _b;
        let urlTimes = `/results/project/${(_a = this.project) === null || _a === void 0 ? void 0 : _a.id}/study/${(_b = this.study) === null || _b === void 0 ? void 0 : _b.id}/global?groupBy=${mode}`;
        window.open(urlTimes, '_blank');
        this.closeModalAction();
    }
    created() { }
    reset() { }
    mounted() { }
    individual() {
        this.downloadReport('individual');
        this.closeModalAction();
    }
    byProductType() {
        this.downloadReport('product_type');
        this.closeModalAction();
    }
    closeModalAction() {
        this.$emit('closeStudy', true);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], StudySummaryDownload.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], StudySummaryDownload.prototype, "study", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], StudySummaryDownload.prototype, "project", void 0);
StudySummaryDownload = __decorate([
    (0, vue_property_decorator_1.Options)({
        emits: ['closeStudy'],
        components: {
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            WidgetCard: bmk_ui_framework_1.WidgetCard,
            PlusIcon: bmk_ui_framework_1.PlusIcon,
            YieldLogo: bmk_ui_framework_1.YieldLogo,
            FarmLogo: bmk_ui_framework_1.FarmLogo,
            TrialsLogo: bmk_ui_framework_1.TrialsLogo,
            RateLogo: bmk_ui_framework_1.RateLogo,
            BizLogo: bmk_ui_framework_1.BizLogo,
            DiseasesLogo: bmk_ui_framework_1.DiseasesLogo,
            LicenseLogo: bmk_ui_framework_1.LicenseLogo,
            ManagementLogo: bmk_ui_framework_1.ManagementLogo,
            OpsLogo: bmk_ui_framework_1.OpsLogo,
            ProposalsLogo: bmk_ui_framework_1.ProposalsLogo,
            ResultsLogo: bmk_ui_framework_1.ResultsLogo,
            TestLogo: bmk_ui_framework_1.TestLogo,
            Button: bmk_ui_framework_1.Button,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            Modal: bmk_ui_framework_1.Modal,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            PinIcon: bmk_ui_framework_1.PinIcon,
            ListIcon: ListIcon_vue_1.default,
            RefreshCcw: lucide_vue_next_1.RefreshCcw,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ViewZero: bmk_ui_framework_1.ViewZero,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            FileText: lucide_vue_next_1.FileText,
        },
    })
], StudySummaryDownload);
exports.default = StudySummaryDownload;
